import {
  User,
  Bell,
  Crown,
  CreditCard,
  FileText,
  Building2,
  Link2,
  Shield,
  Zap
} from 'lucide-react';

export const PLANS = [
  {
    id: 'starter',
    name: 'Starter',
    price: 49,
    period: 'month',
    description: 'Perfect for small lending operations',
    icon: Shield,
    features: [
      'Up to 50 clients',
      'Basic risk assessment',
      'Email support',
      '5 AI summaries/month',
      'Standard reports',
      '1 user seat'
    ],
    limitations: ['No API integrations', 'No custom branding'],
    popular: false
  },
  {
    id: 'professional',
    name: 'Professional',
    price: 149,
    period: 'month',
    description: 'For growing fintech companies',
    icon: Zap,
    features: [
      'Up to 500 clients',
      'Advanced risk scoring',
      'Priority email & chat support',
      '50 AI summaries/month',
      'Custom PDF reports',
      '5 user seats',
      'Credit Bureau API access',
      'Basic analytics dashboard'
    ],
    limitations: [],
    popular: true
  },
  {
    id: 'enterprise',
    name: 'Enterprise',
    price: 499,
    period: 'month',
    description: 'For large-scale operations',
    icon: Crown,
    features: [
      'Unlimited clients',
      'AI-powered risk prediction',
      '24/7 dedicated support',
      'Unlimited AI summaries',
      'White-label reports',
      'Unlimited user seats',
      'All API integrations',
      'Advanced analytics & BI',
      'Custom integrations',
      'SLA guarantee',
      'Dedicated account manager'
    ],
    limitations: [],
    popular: false
  }
];

export const TABS = [
  { id: 'account', label: 'Account', icon: User },
  { id: 'company', label: 'Company', icon: Building2 },
  { id: 'subscription', label: 'Subscription', icon: Crown },
  { id: 'billing', label: 'Billing', icon: CreditCard },
  { id: 'invoices', label: 'Invoices', icon: FileText },
  { id: 'apis', label: 'External APIs', icon: Link2 },
  { id: 'notifications', label: 'Notifications', icon: Bell },
];

export const INITIAL_ACCOUNT_FORM = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  currentPassword: '',
  newPassword: '',
  confirmPassword: ''
};

export const INITIAL_PAYMENT_FORM = {
  cardHolder: '',
  cardNumber: '',
  expiryDate: '',
  billingAddress: '',
  city: '',
  zipCode: '',
  country: ''
};

export const INITIAL_INVOICING_FORM = {
  invoiceEmail: '',
  invoicePrefix: 'INV-',
  paymentTerms: '30',
  currency: 'USD',
  autoSendInvoices: true
};

export const INITIAL_FISCAL_FORM = {
  commercial_name: '',
  legal_name: '',
  address: '',
  zip_code: '',
  neighborhood: '',
  city: '',
  municipality: '',
  state: '',
  country: ''
};

export const INITIAL_API_CONNECTIONS = [
  { id: 'credit_bureau', name: 'Credit Bureau API', provider: 'Experian', status: 'disconnected', apiKey: '' },
  { id: 'syncfy', name: 'Syncfy', provider: 'Syncfy', status: 'disconnected', apiKey: '' },
  { id: 'plaid', name: 'Plaid', provider: 'Plaid', status: 'disconnected', apiKey: '' },
  { id: 'stripe', name: 'Stripe', provider: 'Stripe', status: 'disconnected', apiKey: '' }
];

export const INITIAL_NOTIFICATIONS = {
  paymentSuccess: true,
  paymentFailed: true,
  invoiceGenerated: true,
  subscriptionRenewal: true,
  subscriptionCancelled: true,
  usageLimitWarning: true
};
